import { render } from "./LedgerRow.vue?vue&type=template&id=1dbaffa6&scoped=true"
import script from "./LedgerRow.vue?vue&type=script&lang=js"
export * from "./LedgerRow.vue?vue&type=script&lang=js"

import "./LedgerRow.vue?vue&type=style&index=0&id=1dbaffa6&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbaffa6"]])

export default __exports__